<template>
    <div class="product__form">
        <div class="p-form">
            <div class="p-form__text">Свяжитесь с менеджером, если возникли вопросы или вы не нашли подходящий вариант</div>
            <div class="p-form__form">
                <div class="f-form">
                    <div class="f-form__top">
                        <form @submit.prevent="debounce(validate)" class="form">
                            <div class="form__inputs form__inputs--3">
                                <div class="default-input">
                                    <input v-bind:class="{'default-input__input--error':errors.some(er => er.code === 4)}"
                                           @input="this.reset" v-model="name" autocomplete="off"
                                           class="default-input__input" type="text" placeholder="Имя">
                                    <span v-if="errors.some(er => er.code === 4)" class="default-input__error"></span>
                                </div>
                                <div class="default-input">
                                    <input v-bind:class="{'default-input__input--error':errors.some(er => er.code === 1)}"
                                           @input="this.reset" v-model="phone" autocomplete="off"
                                           class="default-input__input" type="tel" data-mask-phone placeholder="Телефон">
                                    <span v-if="errors.some(er => er.code === 1)" class="default-input__error"></span>
                                </div>
                                <div class="form__submit">
                                    <button class="btn--white" type="submit">Отправить</button>
                                </div>
                            </div>
                            <div style="display: none">
                                <vue-recaptcha
                                    ref="recaptcha"
                                    size="invisible"
                                    :sitekey="this.site_key"
                                    @verify="sendData"
                                    @expired="onCaptchaExpired"
                                />
                            </div>
                        </form>
                    </div>
                    <div class="f-form__warn">Нажимая кнопку, Вы даете информированное
                        <a target="_blanc" :href="modulePolicy.file_src">согласие на обработку своих персональных данных</a></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import recaptcha from "@/components/mixins/recaptcha";
import errors from "@/components/mixins/errors";
import tools from "@/components/mixins/tools";
import { mapState } from 'vuex';
import { reachGoal as ymReachGoal } from "@/modules/metrika";

export default {
    name  : "ManagerCallForm",
    mixins: [recaptcha, errors, tools],
    data() {
        return {
            name: '',
            phone: ''
        }
    },
    computed: {
        ... mapState([
            'modulePolicy'
        ]),
    },
    methods: {
        sendData(recaptchaToken) {
            this.reset();
            let formData = new FormData();
            formData.append('name', this.name);
            formData.append('phone', this.phone);
            formData.append('token', recaptchaToken);
            fetch("/api/manager_call/", {method: 'POST', body: formData})
                .then(response => response.json())
                .then(async resp => {
                    if (resp.success !== true) {
                        let errs = JSON.parse(resp.message);
                        this.parse(errs);
                    } else {
                        ymReachGoal('back_call');
                        window.toast.success('Связь с менеджером', 'Скоро с вами свяжется менеджер.');
                        this.name = '';
                        this.phone = '';
                    }
                });
        }
    }
}
</script>

<style scoped>

</style>
